// Shared layout constants for web pages
export const BOTTOM_NAV_GAP = 32; // space reserved above bottom navigation (px)
export const BOTTOM_SPACER_HEIGHT = 16; // small spacer used inside cards

export const bottomSafeArea = { paddingBottom: BOTTOM_NAV_GAP } as const;
export const spacerStyle = { height: BOTTOM_SPACER_HEIGHT } as const;
